import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import Loading from "../views/Loading.vue";
import PlanTypes from "../views/PlanTypes.vue";
import Waitlist from "../views/Waitlist.vue";
import Faq from "../views/Faq.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/multi-game-plans",
    name: "Multi-Game Plans",
    component: PlanTypes,
    props: {
      type: "multi-game-plans",
    },
  },
  {
    path: "/waitlist",
    name: "Waitlist",
    component: Waitlist,
  },
  {
    path: "/faq",
    name: "Faq",
    component: Faq,
  },
  { path: "/:pathMatch(.*)*", component: Loading },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 };
  },
});
router.beforeEach((to, from, next) => {
  next();
});
router.afterEach((to, from, next) => {
  document.title =
    to.name === "Home" ? "Ticket Finder" : to.name ?? "Ticket Finder";
});
export default router;
